import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../../assets/images/letsmakeadeal.jpg';
import WhatsAppButton from './WhatsAppButton';
import './Header.css';

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const location = useLocation();

    const isActive = (path) => location.pathname === path;

    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

    const handleNavClick = () => {
        setIsMenuOpen(false);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <header className="header">
            <Link to="/" className="logo" onClick={handleNavClick}>
                <img src={logo} alt="Real Estate Logo" />
            </Link>

            <button className="mobile-menu-button" onClick={toggleMenu}>
                {isMenuOpen ? '✕' : '☰'}
            </button>

            <nav>
                <ul className={`nav-links ${isMenuOpen ? 'open' : ''}`}>
                    <li>
                        <Link
                            to="/"
                            className={`nav-link ${isActive('/') ? 'active' : ''}`}
                            onClick={handleNavClick}
                        >
                            Home
                        </Link>
                    </li>
                    <li>
                        <Link
                            to="/properties"
                            className={`nav-link ${isActive('/properties') ? 'active' : ''}`}
                            onClick={handleNavClick}
                        >
                            Properties
                        </Link>
                    </li>
                    <li>
                        <Link
                            to="/about"
                            className={`nav-link ${isActive('/about') ? 'active' : ''}`}
                            onClick={handleNavClick}
                        >
                            About
                        </Link>
                    </li>
                    <li>
                        <Link
                            to="/contact"
                            className={`nav-link ${isActive('/contact') ? 'active' : ''}`}
                            onClick={handleNavClick}
                        >
                            Contact
                        </Link>
                    </li>
                </ul>
            </nav>

            <div className="header-right">
                <WhatsAppButton variant="header" />
            </div>
        </header>
    );
};

export default Header;